import React from "react";
import logo from "../../assets/ic_launcher.png";

const Footer: React.FC = () => {
  return (
    <footer className="relative bg-gray-900 text-gray-300 pt-12 pb-8">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row justify-between items-start gap-12">
          {/* Logo & Description */}
          <div className="flex-1 min-w-[240px]">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={logo}
                alt="VendorOrbis Logo"
                className="h-10 object-contain"
              />
              <span className="text-2xl font-bold text-blue-500">
                VendorOrbis
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              The point-of-sale and back office for market, craft fair, and
              pop-up vendors. Track inventory, staff, expenses, and sales by
              event, and know which shows make you money.
            </p>
          </div>

          {/* Footer Links */}
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-8 text-sm w-full md:w-auto">
            {/* Resources */}
            <div>
              <h3 className="text-lg font-semibold mb-3 text-white">
                Resources
              </h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://vendororbis.featurebase.app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Suggestions
                  </a>
                </li>
                <li>
                  <a
                    href="https://vendororbis.featurebase.app/changelog"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Changelog
                  </a>
                </li>
                <li>
                  <a href="/faq" className="hover:text-white">
                    FAQ
                  </a>
                </li>
              </ul>
            </div>

            {/* Legal */}
            <div>
              <h3 className="text-lg font-semibold mb-3 text-white">Legal</h3>
              <ul className="space-y-2">
                <li>
                  <a href="/terms-and-condition" className="hover:text-white">
                    Terms and Conditions
                  </a>
                </li>
                <li>
                  <a href="/privacy-policy" className="hover:text-white">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a href="/eula" className="hover:text-white">
                    EULA
                  </a>
                </li>
              </ul>
            </div>

            {/* Social */}
            <div>
              <h3 className="text-lg font-semibold mb-3 text-white">Social</h3>
              <ul className="space-y-2">
                <li>
                  <a
                    href="https://discord.gg/UQmQw3bnhs"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    Discord
                  </a>
                </li>
                <li>
                  <a
                    href="https://x.com/vendororbis"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    X (Twitter)
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Divider & Copyright */}
        <div className="mt-12 border-t border-gray-700 pt-6 text-sm text-center text-gray-500">
          &copy; {new Date().getFullYear()} VendorOrbis. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
